export class ExtendableError extends Error {}

export class ApiRequestError extends ExtendableError {
    constructor(message = 'Api Request Error', args) {
        super(message);
        this.code = 'EAPIREQUEST';
        this.callArgs = args;
    }
}

export class NotFoundError extends ExtendableError {
    constructor(message = 'Not found') {
        super(message);
        this.code = 'ENOTFOUND';
    }
}

export class RenderToStringError extends ExtendableError {
    constructor(message = 'Failed render to string') {
        super(message);
        this.code = 'ERENDERTOSTRING';
    }
}

export class InternalUserValidationError extends ExtendableError {
    constructor(message = 'Validation error') {
        super(message);
        this.code = 'EINTERNALUSERVALIDATION';
    }
}

export class ExternalUserValidationError extends ExtendableError {
    constructor(message = 'Validation error', errors = []) {
        super(message);
        this.code = 'EEXTERNALUSERVALIDATION';
        this.errors = errors;
    }
}
